import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LayoutSlider } from "../../components/LayoutSlider";
import { HomeMAndV } from "../../components/HomeMAndV";
import { HomeAllies } from "../../components/HomeAllies";
import { ContactForm } from "../../components/ContactForm";
import "./Home.css";

import image1 from '../../assets/home/modalHome/imagen1.png';
import image2 from '../../assets/home/modalHome/imagen2.png';
import image3 from '../../assets/home/modalHome/imagen3.png';
import image4 from '../../assets/home/modalHome/imagen4.png';
import image5 from '../../assets/home/modalHome/imagen5.png';
import image6 from '../../assets/home/modalHome/imagen6.png';
// import image7 from '../../assets/home/modalHome/imagen7.png';
// import image8 from '../../assets/home/modalHome/imagen8.jpg';

const imagesWithLinks = [
  { src: image1, link: "https://api.whatsapp.com/send?phone=573165294689" },
  { src: image2, link: "https://api.whatsapp.com/send?phone=573105610135" },
  { src: image3, link: "https://api.whatsapp.com/send?phone=573054009393" },
  { src: image4, link: "https://api.whatsapp.com/send?phone=573054009393" },
  { src: image5, link: "https://api.whatsapp.com/send?phone=573105610135" },
  { src: image6, link: "https://api.whatsapp.com/send?phone=573105610135" },
  // { src: image8, link: "https://api.whatsapp.com/send?phone=573144422577" },
];

const Home = ({ showModal }) => {

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // Opcional: scroll suave
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const imageShown = sessionStorage.getItem('imageShown');

    if (!imageShown) {
      const randomImage = imagesWithLinks[Math.floor(Math.random() * imagesWithLinks.length)];
      sessionStorage.setItem('imageShown', 'true');
      
      showModal(
        <a href={randomImage.link} target="_blank" rel="noopener noreferrer">
          <img src={randomImage.src} className='img-fluid'  alt="Imagen aleatoria" />
          <button className="w-100 btn btn-dark text-white ">CONOCER MAS</button>
        </a>
      );
    }
  }, [showModal]);

  return (
    <div>
      <LayoutSlider />
      <HomeMAndV />
      <HomeAllies />
      <ContactForm />
    </div>
  );
};

export { Home };